import { AutoNumber } from '../../types';

import { carsActions } from '../reducer';

export const updateSelectedCarLocationAutoNumber = (
  autoNumber: AutoNumber
) => carsActions.setSelectedLocationSharingAutoNumber(autoNumber);
